export default [
    {
        component: () => import(/* webpackChunkName: 'cadastro-especialidade' */ '@/views/cadastro/especialidade/Index'),
        path: 'especialidade',
        redirect: 'especialidade/index',
        children: [
            {
                component: () => import(/* webpackChunkName: 'cadastro-especialidade' */ '@/views/cadastro/especialidade/List.vue'),
                name: 'cadastro-especialidade-index',
                path: 'index',
            },
            {
                component: () => import(/* webpackChunkName: 'cadastro-especialidade' */ '@/views/cadastro/especialidade/Form.vue'),
                name: 'cadastro-especialidade-create',
                path: 'create',
            },
            {
                component: () => import(/* webpackChunkName: 'cadastro-especialidade' */ '@/views/cadastro/especialidade/Form.vue'),
                name: 'cadastro-especialidade-edit',
                path: 'edit/:id',
                props: route => ({ id: parseInt(route.params.id) }),
            },
        ],
    },
]